<template>
    <div class="account-show">
        <main>
            <DCard padding>
                <div class="detail">
                    <div>
                        <span>{{ __('products.fulfillmentAccounts.form.accountGroup') }}</span>
                        <span>{{ account.group.name }}</span>
                    </div>
                    <div>
                        <span>{{ __('products.fulfillmentAccounts.form.name') }}</span>
                        <span>{{ account.name }}</span>
                    </div>
                    <div>
                        <span>{{ __('products.fulfillmentAccounts.form.hostname') }}</span>
                        <span>{{ account.hostname }}</span>
                    </div>
                    <div>
                        <span>{{ __('products.fulfillmentAccounts.form.username') }}</span>
                        <span>{{ account.username }}</span>
                    </div>
                    <div>
                        <span>{{ __('products.fulfillmentAccounts.form.status') }}</span>
                        <span>{{ account.status }}</span>
                    </div>
                    <div>
                        <span>{{ __('products.fulfillmentAccounts.form.maxInstances') }}</span>
                        <span>{{ account.max_instances }}</span>
                    </div>
                    <div>
                        <span>{{ __('products.fulfillmentGroups.form.tag') }}</span>
                        <span v-if="account.tags.length > 0">
                            <DTag
                                v-for="tag in account.tags"
                                :key="tag.id"
                                class="m-1"
                                :label="tag.name"
                            />
                        </span>
                        <span v-else>
                            <DTag
                                :label="__('messages.not_set')"
                            />
                        </span>
                    </div>
                    <div>
                        <span>{{ __('products.fulfillmentAccounts.form.additionalData') }}</span>
                        <span>
                            <DFormTextarea
                                id="additional_data"
                                v-model="additionalDataJson"
                                rows="10"
                                :disabled="true"
                            />
                        </span>
                    </div>
                </div>
            </DCard>
        </main>

        <DFabs>
            <DFab
                v-if="adminSsoSupported"
                color="secondary"
                icon="lan-connect"
                :label="__('products.fulfillmentAccounts.index.singleSignOn')"
                @click="adminLoginViaSSO(account.id)"
            />
            <DFab
                v-if="userPermissions.includes('fulfillment.edit')"
                id="btn-edit"
                icon="pencil"
                :label="__('messages.actions.edit')"
                @click="$inertia.get($route('products.accounts.edit', account.id))"
            />
        </DFabs>
    </div>
</template>

<script>

export default {
    name: 'FulfillmentAccountShow',
    props: {
        account: {
            type: Object,
            default: () => { return {} }
        },
        adminSsoSupported: {
            type: Boolean,
            default: () => { return false }
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        },
        additionalDataJson () {
            return JSON.stringify(this.account.data, null, 6)
        }
    },
    methods: {
        async generateAdminSSOLink (id) {
            const self = this
            try {
                const response = await window.axios.get(this.$route('products.accounts.sso', id))
                self.loginStatus = ''
                self.ssoLink = response.data.url
            } catch (e) {
                self.loginStatus = 'failed'
            }
        },
        login () {
            window.open(this.ssoLink, '_blank').focus()
        },
        async adminLoginViaSSO (id) {
            await this.generateAdminSSOLink(id)
            this.login()
        }
    }
}
</script>

<style lang="scss" scoped>
.account-show {
    display: grid;
    grid-gap: 15px;

    & main {
        display: flex;
        flex-direction: column;
        grid-gap: 15px;

        & .detail {
            display: flex;
            flex-direction: column;
            grid-gap: 15px;

            & > div {
                display: grid;
                grid-template-columns: 1fr 3fr;
                grid-gap: 15px;

                & span:nth-child(1) {
                    font-weight: bold;
                }

                & span:nth-child(2) {
                    line-height: 1.5em;
                    word-break: break-all;
                }
            }
        }
    }
}
</style>
